import {
  DirectionsWalkRoundedIcon,
  EmojiEventsRoundedIcon,
  ExerciseIcon,
  FitnessCenterRoundedIcon,
  LocalDrinkRoundedIcon,
  NutritionIcon,
  SleepIcon,
  StressIcon,
} from 'src/components/atoms/webmdhs-icon';
import AsthmaIcon from 'src/components/atoms/webmdhs-icon/asthma-icon/AsthmaIcon';
import BackHealthIcon from 'src/components/atoms/webmdhs-icon/back-health-icon/BackHealthIcon';
import BalancedLivingIcon from 'src/components/atoms/webmdhs-icon/balanced-living-icon/BalancedLivingIcon';
import CadIcon from 'src/components/atoms/webmdhs-icon/cad-icon/CadIcon';
import CopdIcon from 'src/components/atoms/webmdhs-icon/copd-icon/CopdIcon';
import MoodIcon from 'src/components/atoms/webmdhs-icon/mood-icon/MoodIcon';
import DiabetesIcon from 'src/components/atoms/webmdhs-icon/diabetes-icon/DiabetesIcon';
import HearthFailureIcon from 'src/components/atoms/webmdhs-icon/hearth-failure-icon/HearthFailureIcon';
import HypertensionIcon from 'src/components/atoms/webmdhs-icon/hypertension-icon/HypertensionIcon';
import MaternalHealthIcon from 'src/components/atoms/webmdhs-icon/maternal-health-icon/MaternalHealthIcon';
import PregnantPartnerIcon from 'src/components/atoms/webmdhs-icon/pregnant-partner-icon/PregnantPartnerIcon';
import StayConnectedIcon from 'src/components/atoms/webmdhs-icon/stay-connected-icon/StayConnectedIcon';
import TobaccoIcon from 'src/components/atoms/webmdhs-icon/tobacco-icon/TobaccoIcon';
import WeightIcon from 'src/components/atoms/webmdhs-icon/weight-icon/WeightIcon';
import WorkLifeBalanceIcon from 'src/components/atoms/webmdhs-icon/work-life-balance-icon/WorkLifeBalanceIcon';
import TrackerHypertensionIcon from 'src/components/atoms/webmdhs-icon/tracker-hypertension-icon/TrackerHypertensionIcon';
import Accessibility24pxIcon from 'src/components/atoms/webmdhs-icon/accessibility-24px-icon/Accessibility24pxIcon';
import CaloriesBurnedIcon from 'src/components/atoms/webmdhs-icon/calories-burned-icon/CaloriesBurnedIcon';
import CholesterolIcon from 'src/components/atoms/webmdhs-icon/cholesterol-icon/CholesterolIcon';
import Assignment24pxIcon from 'src/components/atoms/webmdhs-icon/assignment24px-icon/Assignment24pxIcon';
import TrackerExerciseIcon from 'src/components/atoms/webmdhs-icon/tracker-exercise-icon/TrackerExerciseIcon';
import StepsIcon from 'src/components/atoms/webmdhs-icon/steps-icon/StepsIcon';
import RemoveRedEyeIcon from 'src/components/atoms/webmdhs-icon/remove-red-eye-icon/RemoveRedEyeIcon';
import ExpiratoryFlowIcon from 'src/components/atoms/webmdhs-icon/expiratory-flow-icon/ExpiratoryFlowIcon';
import HeightIcon from 'src/components/atoms/webmdhs-icon/height-icon/HeightIcon';
import HighBloodSugarIcon from 'src/components/atoms/webmdhs-icon/high-blood-sugar-icon/HighBloodSugarIcon';
import LowBloodSugarIcon from 'src/components/atoms/webmdhs-icon/low-blood-sugar-icon/LowBloodSugarIcon';
import MedicationIcon from 'src/components/atoms/webmdhs-icon/medication-icon/MedicationIcon';
import WbSunnyIcon from 'src/components/atoms/webmdhs-icon/wb-sunny-icon/WbSunnyIcon';
import PainIcon from 'src/components/atoms/webmdhs-icon/pain-icon/PainIcon';
import UrineProteinLevelIcon from 'src/components/atoms/webmdhs-icon/urine-protein-level-icon/UrineProteinLevelIcon';
import StraightenIcon from 'src/components/atoms/webmdhs-icon/straighten-icon/StraightenIcon';
import TrackerDiabetesIcon from 'src/components/atoms/webmdhs-icon/tracker-diabetes-icon/TrackerDiabetesIcon';
import TrackerTobaccoIcon from 'src/components/atoms/webmdhs-icon/tracker-tobacco-icon/TrackerTobaccoIcon';
import AdvocateIcon from 'src/components/atoms/webmdhs-icon/advocate-icon/AdvocateIcon';
import GroupIcon from 'src/components/atoms/webmdhs-icon/group-icon/GroupIcon';
import SocialWellbeingIcon from 'src/components/atoms/webmdhs-icon/social-wellbeing-icon/SocialWellbeingIcon';
import { ChallengeTypes, DailyHabitTypes, HealthGoalRate, StreamTypes, TrackerTypes, IconTopicType } from './enums';

export const ERROR_MESSAGES = {
  invalidProp: (propName: string): string => `The ${propName} prop is required and cannot be empty.`,
  tokenNotProvided: 'Token is not provided.',
  invalidApiEndpoint: 'API endpoint is not defined.',
  invalidAccessToken: 'Access token is not defined.',
  cannotUseStore: 'useStore must be used within StoreProvider.',
  cannotCallApi: (endpoint: string): string => `Failed to call api ${endpoint}.`,
  unexpectedErrorFromApi: (endpoint: string): string => `An unexpected error occurred while calling ${endpoint}.`,
  unknownErrorFromApi: (endpoint: string): string => `An unknown error occurred while calling ${endpoint}.`,
  unknownError: 'Unknown error occurred.',
  missingUrl: 'Url is required.',
  missingIcon: (streamId: string): string => `Missing icon for ${streamId}.`,
  unexpectedStateError: (storeName: string, details: string): string =>
    `Unexpected state error in ${storeName}: ${details}`,
  globalError: (message: string): string => `Global JavaScript error: ${message}`,
  unhandledPromiseRejection: (reason: string): string => `Unhandled Promise Rejection: ${reason}`,
  missingStackTrace: 'No StackTrace available.',
  cannotUseuseTeamsUser: 'useTeamsUser must be used within a TeamsUserProvider.',
  invalidProgramType: (programType: string): string => `Program type is invalid: ${programType}`,
  invalidAvailabilityState: (state: string): string => `Unknown program availability state: ${state}`,
  invalidDailyHabitsType: (planId: string): string => `DailyHabits type is invalid: ${planId}`,
  invalidExperienceType: (experienceId?: string): string => `Experience type is invalid: ${experienceId}`,
  invalidHealthTrackerType: (healthTrackerId: string): string => `Health tracker type is invalid: ${healthTrackerId}`,
  invalidHealthGoalType: (healthGoalType: string): string => `Health goal type is invalid: ${healthGoalType}`,
  invalidIconTopicType: (iconTopicType: string): string => `Icon topic type is invalid: ${iconTopicType}`,
};

export const STREAM_MAP_WITH_ICON: Record<StreamTypes, string> = {
  [StreamTypes.ASTHMA]: 'icons/circle-sleep.svg',
  [StreamTypes.CAD]: 'icons/circle-sleep.svg',
  [StreamTypes.COPD]: 'icons/circle-sleep.svg',
  [StreamTypes.DIABETES]: 'icons/circle-sleep.svg',
  [StreamTypes.EXERCISE]: 'icons/circle-sleep.svg',
  [StreamTypes.HEARTHFAILURE]: 'icons/circle-heart.svg',
  [StreamTypes.HIGHBOOLPRESSURE]: 'icons/circle-sleep.svg',
  [StreamTypes.HIGHCHOLESTEROL]: 'icons/circle-sleep.svg',
  [StreamTypes.NUTRITION]: 'icons/circle-nutrition.svg',
  [StreamTypes.SLEEP]: 'icons/circle-sleep.svg',
  [StreamTypes.STRESS]: 'icons/circle-sleep.svg',
  [StreamTypes.TOBACCO]: 'icons/circle-sleep.svg',
  [StreamTypes.WEIGHT]: 'icons/circle-sleep.svg',
};

export const AXIOS_CONFIG = {
  MAX_RETRIES: 3,
  RETRY_DELAY_IN_MILLISECONDS: 2000,
  TIMEOUT_IN_MILLISECONDS: 10000,
};

export const THOUSAND_UNIT = 'k';

export const ICON_SIZE = '40px';

export const TOOL_IDS = {
  CHALLENGE: '713',
};

export const CHALLENGES_CONFIG = {
  [ChallengeTypes.StepBattle]: { icon: DirectionsWalkRoundedIcon, color: '#427D40' },
  [ChallengeTypes.Steps]: { icon: ExerciseIcon, color: '#6467D9' },
  [ChallengeTypes.Exercise]: { icon: FitnessCenterRoundedIcon, color: '#6467D9' },
  [ChallengeTypes.Nutrition]: { icon: NutritionIcon, color: '#D1414E' },
  [ChallengeTypes.Sleep]: { icon: SleepIcon, color: '#3D62C5' },
  [ChallengeTypes.Stress]: { icon: StressIcon, color: '#007CB6' },
  [ChallengeTypes.Water]: { icon: LocalDrinkRoundedIcon, color: '#2473D4' },
  [ChallengeTypes.Custom]: { icon: EmojiEventsRoundedIcon, color: '#0078BF' },
};

export const DAILY_HABITS_CONFIG = {
  [DailyHabitTypes.Asthma]: { icon: AsthmaIcon, color: '#8c437f' },
  [DailyHabitTypes.BackHealth]: { icon: BackHealthIcon, color: '#AC153d' },
  [DailyHabitTypes.BalancedLiving]: { icon: BalancedLivingIcon, color: '#6467d9' },
  [DailyHabitTypes.CAD]: { icon: CadIcon, color: '#048188' },
  [DailyHabitTypes.COPD]: { icon: CopdIcon, color: '#427d40' },
  [DailyHabitTypes.CopeBlues]: { icon: MoodIcon, color: '#048188' },
  [DailyHabitTypes.Diabetes]: { icon: DiabetesIcon, color: '#d1414e' },
  [DailyHabitTypes.Exercise]: { icon: ExerciseIcon, color: '#6467d9' },
  [DailyHabitTypes.HeartFailure]: { icon: HearthFailureIcon, color: '#068266' },
  [DailyHabitTypes.Hypertension]: { icon: HypertensionIcon, color: '#2473d4' },
  [DailyHabitTypes.MaternalHealthTrimester1]: { icon: MaternalHealthIcon, color: '#6a6ec2' },
  [DailyHabitTypes.MaternalHealthTrimester2]: { icon: MaternalHealthIcon, color: '#6a6ec2' },
  [DailyHabitTypes.MaternalHealthTrimester3]: { icon: MaternalHealthIcon, color: '#6a6ec2' },
  [DailyHabitTypes.Nutrition]: { icon: NutritionIcon, color: '#ae2573' },
  [DailyHabitTypes.PregnantPartner]: { icon: PregnantPartnerIcon, color: '#895bbe' },
  [DailyHabitTypes.SleepWell]: { icon: SleepIcon, color: '#3D62C5' },
  [DailyHabitTypes.StayConnected]: { icon: StayConnectedIcon, color: '#156C72' },
  [DailyHabitTypes.Stress]: { icon: StressIcon, color: '#007cb6' },
  [DailyHabitTypes.Tobacco]: { icon: TobaccoIcon, color: '#895bbe' },
  [DailyHabitTypes.Weight]: { icon: WeightIcon, color: '#007ea2' },
  [DailyHabitTypes.WorkLifeBalance]: { icon: WorkLifeBalanceIcon, color: '#007cb6' },
};

export const TRACKERS_CONFIG = {
  [TrackerTypes.BloodPressure]: { icon: TrackerHypertensionIcon, color: '#2473D4' },
  [TrackerTypes.PercentBodyFat]: { icon: Accessibility24pxIcon, color: '#007EA2' },
  [TrackerTypes.CaloriesBurned]: { icon: CaloriesBurnedIcon, color: '#6467D9' },
  [TrackerTypes.Cholesterol]: { icon: CholesterolIcon, color: '#CE2955' },
  [TrackerTypes.Triglycerides]: { icon: CholesterolIcon, color: '#CE2955' },
  [TrackerTypes.BreastSelfExam]: { icon: Assignment24pxIcon, color: '#068266' },
  [TrackerTypes.ColorectalScreen]: { icon: Assignment24pxIcon, color: '#068266' },
  [TrackerTypes.FootExam]: { icon: Assignment24pxIcon, color: '#068266' },
  [TrackerTypes.ProstateCancerScreening]: { icon: Assignment24pxIcon, color: '#068266' },
  [TrackerTypes.PapSmear]: { icon: Assignment24pxIcon, color: '#068266' },
  [TrackerTypes.Mammogram]: { icon: Assignment24pxIcon, color: '#068266' },
  [TrackerTypes.Diet]: { icon: NutritionIcon, color: '#AE2573' },
  [TrackerTypes.Exercise]: { icon: TrackerExerciseIcon, color: '#6467D9' },
  [TrackerTypes.Steps]: { icon: StepsIcon, color: '#6467D9' },
  [TrackerTypes.EyeExam]: { icon: RemoveRedEyeIcon, color: '#068266' },
  [TrackerTypes.FastingBloodSugar]: { icon: TrackerDiabetesIcon, color: '#D1414E' },
  [TrackerTypes.NonFastingBloodSugar]: { icon: TrackerDiabetesIcon, color: '#D1414E' },
  [TrackerTypes.HemoglobinA1C]: { icon: TrackerDiabetesIcon, color: '#D1414E' },
  [TrackerTypes.ForcedExpiratoryVolume]: { icon: ExpiratoryFlowIcon, color: '#8C437F' },
  [TrackerTypes.PeakExpiratoryFlow]: { icon: ExpiratoryFlowIcon, color: '#8C437F' },
  [TrackerTypes.Height]: { icon: HeightIcon, color: '#007EA2' },
  [TrackerTypes.HighBloodSugar]: { icon: HighBloodSugarIcon, color: '#D1414E' },
  [TrackerTypes.SleepHours]: { icon: SleepIcon, color: '#3D62C5' },
  [TrackerTypes.LowBloodSugar]: { icon: LowBloodSugarIcon, color: '#D1414E' },
  [TrackerTypes.Medication]: { icon: MedicationIcon, color: '#068266' },
  [TrackerTypes.Mood]: { icon: WbSunnyIcon, color: '#007CB6' },
  [TrackerTypes.Pain]: { icon: PainIcon, color: '#068266' },
  [TrackerTypes.RescueInhalerUse]: { icon: AsthmaIcon, color: '#8C437F' },
  [TrackerTypes.RestingHeartRate]: { icon: HearthFailureIcon, color: '#068266' },
  [TrackerTypes.Stress]: { icon: StressIcon, color: '#007CB6' },
  [TrackerTypes.MindfulnessMinutes]: { icon: StressIcon, color: '#007CB6' },
  [TrackerTypes.TobaccoUse]: { icon: TrackerTobaccoIcon, color: '#895BBE' },
  [TrackerTypes.UrineProtienLevel]: { icon: UrineProteinLevelIcon, color: '#068266' },
  [TrackerTypes.WaistMeasurement]: { icon: StraightenIcon, color: '#007EA2' },
  [TrackerTypes.Weight]: { icon: WeightIcon, color: '#007EA2' },
};

export const STORE_NAME = {
  AUTH_STORE: 'AuthStore',
  PROFILE_STORE: 'ProfileStore',
  ACTIVITIES_STORE: 'ActivitiesStore',
  REWARDS_STORE: 'RewardsStore',
  DAILY_HABITS_STORE: 'DailyHabitsStore',
  HEALTH_TRACKERS_STORE: 'HealthTrackersStore',
  HEALTH_GOALS_STORE: 'HealthGoalsStore',
  HOME_WIDGET_TEXT_STORE: 'HomeWidgetTextStore',
};

// Stroke width is 8% of the viewBox size (100)
export const STROKE_WIDTH_RATIO = 0.08;

export const MAXIMUM_ACTIVE_PLANS = 3;
export const MAXIMUM_PINNED_HEALTH_GOALS = 3;

export const SELECT_PLANS_URL = '/!goals/plans/selectplans';
export const GOALS_PLANS_URL = '/!goals/plans';
export const HEALTH_GOALS_PAGE = '/HealthGoals/Member';

export const WHS_TOKEN_KEY = 'whsToken:AccessToken';
export const WHS_TOKEN_EXPIRY_KEY = 'whsToken:expiryTime';
export const WHS_USER_KEY = 'whsUser:UserInfo';

export const PLURAL = 'Plural';
export const SINGULAR = 'Singular';

export const DAILY_HABIT_EXPIRED_IMAGE_PATHS = {
  COMPLETED_ALL: '/images/CompletedAll.svg',
  COMPLETED_MOST: '/images/CompletedMost.svg',
  INCOMPLETE_ALL: '/images/IncompleteAll.svg',
  INCOMPLETE_MOST: '/images/IncompleteMost.svg',
};

export const DAILY_HABIT_TEXT_KEYS = {
  NOT_NOW: 'DailyHabitsWidget:Button:NotNow',
  MANAGE_PLANS: 'DailyHabitsWidget:Button:ManagePlans',
};

export const DEFAULT_TODAY_TAB_VALUE = 'today';
export const PLAY_IMG = '/images/playCircleOutlined.png';

export const TIME_UNITS = {
  SECOND: 'second',
  MINUTE: 'minute',
  HOUR: 'hour',
  DAY: 'day',
  MONTH: 'month',
  YEAR: 'year',
  SECONDS: 'seconds',
  MINUTES: 'minutes',
  HOURS: 'hours',
  DAYS: 'days',
  MONTHS: 'months',
  YEARS: 'years',
  TODAY: 'Today',
};

export const WEDMD_URL = 'https://www.webmdhealthservices.com/';

export const HEALTH_GOAL_RATE_TEXT = {
  [HealthGoalRate.PerDay]: 'day',
  [HealthGoalRate.PerCalWeek]: 'week',
  [HealthGoalRate.PerCalMonth]: 'month',
  [HealthGoalRate.PerCalQuarter]: 'quarter',
  [HealthGoalRate.PerCalYear]: 'year',
  [HealthGoalRate.PerDateRange]: '',
};

export const ICON_TOPIC_CONFIG = {
  [IconTopicType.Advocate]: { icon: AdvocateIcon, color: '#ffffff' },
  [IconTopicType.BalancedLiving]: { icon: BalancedLivingIcon, color: '#ffffff' },
  [IconTopicType.Exercise]: { icon: ExerciseIcon, color: '#ffffff' },
  [IconTopicType.Group]: { icon: GroupIcon, color: '#ffffff' },
  [IconTopicType.Nutrition]: { icon: NutritionIcon, color: '#ffffff' },
  [IconTopicType.Sleep]: { icon: SleepIcon, color: '#ffffff' },
  [IconTopicType.SocialWellbeing]: { icon: SocialWellbeingIcon, color: '#ffffff' },
  [IconTopicType.Stress]: { icon: StressIcon, color: '#ffffff' },
  [IconTopicType.Weight]: { icon: WeightIcon, color: '#ffffff' },
};

export const ICON_TOPIC_BACKGROUND_COLOR = '#616161';

export const STEP_BATTLE_BACKGROUND_IMAGE = '/images/StepBattle_Background.png';
